/**
 * Created by Mark on 05/04/2017.
 */


import React from 'react';
import {PieChart, Pie}  from 'recharts';

export default class BarGraph extends React.Component {

    constructor(props){
        super();
        this.props = props;
        this.state = {
            id: this.props.id || Math.random(),
            index: this.props.index || 0,
            dataKeys:  [{key:'reading' , fill:'#fd470a'} , {key:'listening' , fill:'#ff8417'} , {key:'writing' , fill:'#fa74b7'} , {key:'speaking' , fill:'#1b9ff6'}],
            height:this.props.height || 100,
            data:this.props.data || [{name: '' , value: 100 , fill:"#ffffff" }, {name: '' , value: 300 , fill:"none"}]
        }

        this.updateDimensions  =   this.updateDimensions.bind(this)
    }

    componentWillReceiveProps(props){

        this.props = props;
        this.setState({
            id: this.props.id || Math.random(),
            index: this.props.index || 0,
            dataKeys:  [{key:'reading' , fill:'#fd470a'} , {key:'listening' , fill:'#ff8417'} , {key:'writing' , fill:'#fa74b7'} , {key:'speaking' , fill:'#1b9ff6'}],
            height:this.props.height || 100,
            data:this.props.data || [{name: '' , value: 100 , fill:"#ffffff" }, {name: '' , value: 300 , fill:"none"}]
        });

        this.updateDimensions  =   this.updateDimensions.bind(this)
    }
    

    updateDimensions(){
        var element = document.getElementById(this.state.id);
        if (element != undefined && element != null) {
            this.setState({
                width:element.clientWidth
            })
        }
    }

    componentDidMount() {
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }


    render(){
        return(
            <div id={this.state.id}>
                <PieChart width={this.state.width} height={this.state.height} >
                    <Pie
                        activeIndex={this.state.index}

                        data={this.state.data}
                        cx={this.state.width/2}
                        cy={this.state.height/2}
                        innerRadius={(this.state.height/2)*0.6}
                        outerRadius={(this.state.height/2)*0.7}/>
                </PieChart>
            </div>
        )
    }

}